import "slick-carousel/slick/slick.css";
import "@/assets/lib/slick-theme.css";
// @ts-ignore
import $ from "jquery";
import "slick-carousel";
import setupSlickArrowMobileFeedback from "./slick-arrow-mobile-feedback";

export default function SlickCarouselThumbs() {
  const slickElement = document.querySelectorAll<HTMLDivElement>(".js-slick-carousel-thumbs");

  if (slickElement && slickElement.length > 0) {
    slickElement.forEach((el: HTMLDivElement) => {
      if (el) {
        const carouselEl = el.querySelector<HTMLDivElement>(".js-slick");
        const carouselElThumbs = el.querySelector<HTMLDivElement>(".js-slick-thumbs");
        const slides = el.querySelectorAll<HTMLDivElement>(".js-item");
        const slideThumbs = el.querySelectorAll<HTMLDivElement>(".js-thumb-item");
        const nextButton = el.querySelector<HTMLButtonElement>(".slick-btn-next");
        const previousButton = el.querySelector<HTMLButtonElement>(".slick-btn-prev");
        const delay = el.getAttribute("data-delay");
        const shouldAutoplay = el.getAttribute("data-autoplay")?.toLowerCase() === "true" ? true : false;
        const showDotNav = el.getAttribute("data-dots")?.toLowerCase() === "true" ? true : false;

        if (carouselEl && slides && slides.length > 1 && slideThumbs) {
          $(carouselEl).slick({
            infinite: true,
            autoplay: shouldAutoplay,
            autoplaySpeed: delay ? parseInt(delay) * 1000 : 0,
            slidesToShow: 1,
            asNavFor: carouselElThumbs,
            arrows: !!nextButton && !!previousButton,
            prevArrow: previousButton,
            nextArrow: nextButton,
            dots: showDotNav,
          });

          setupSlickArrowMobileFeedback(carouselEl, previousButton, nextButton);

          $(carouselElThumbs).slick({
            slidesToShow: slideThumbs.length,
            slidesToScroll: 1,
            asNavFor: carouselEl,
          });

          //Slick slider navigate to the respective index.
          slideThumbs.forEach((thumb, index) => {
            $(thumb).click(function () {
              $(carouselEl).slick("slickGoTo", index);
            });
          });
        }
      }
    });
  }
}
